import { createAction } from '@reduxjs/toolkit';
import { normalizeError } from 'core/common/errors';
import { SpanName } from 'core/common/observability/entities';
import { AppThunk } from 'core/common/store/types';
import { fetchUserInformation, syncUtmTags } from 'core/user/store';

export const signInByTokenPending = createAction('auth/SIGN_IN_BY_TOKEN/pending');
export const signInByTokenSucceed = createAction<string>('auth/SIGN_IN_BY_TOKEN/succeed');
export const signInByTokenFailed = createAction('auth/SIGN_IN_BY_TOKEN/failed');

export const signInByToken =
  (token: string): AppThunk =>
  async (dispatch, _, context) => {
    const { authService, loggingService, observabilitySystem } = context;

    const span = observabilitySystem.startSpan(SpanName.SIGN_IN_BY_TOKEN);

    try {
      dispatch(signInByTokenPending());

      await authService.signInByToken(token);
      const { authenticationToken } = await authService.getAskNebulaAuthenticationToken();

      dispatch(fetchUserInformation());
      dispatch(signInByTokenSucceed(authenticationToken));
      dispatch(syncUtmTags());

      span.succeed();
    } catch (e) {
      const err = normalizeError(e);
      loggingService.error(err);

      dispatch(signInByTokenFailed());

      span.fail(err);
    }
  };
